import { Fragment, useContext } from "react";
import { Navbar, Dropdown, Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { ProfileContext } from "../../Auth/ProfileProvider";
import { ApplicationPaths } from "../../Services/Auth/AuthConstants";
import ABPNNavLink from "../../Shared/Components/ABPNNavLink";

export default function NavMenu() {
    const { user, updateSelectedTrainingProgramId } = useContext(ProfileContext);
    const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
    const navigate = useNavigate();

    const changeProgram = (trainingProgramId: number) => {
        updateSelectedTrainingProgramId(trainingProgramId);
        navigate("/");
    }

    const getProgramName = (trainingProgramId: number) => {
        var trainingProgram = user.trainingPrograms.find(_ => _.trainingProgramId === trainingProgramId);
        return trainingProgram?.trainingProgramName1;
    }
    const getSpecialtyName = (trainingProgramId: number) => {
        var trainingProgram = user.trainingPrograms.find(_ => _.trainingProgramId === trainingProgramId);
        return trainingProgram ? `${trainingProgram.trainingProgramCode} | ${trainingProgram.trainingProgramTypeName}` : '';
    }
    const getRoleName = () => user.userRole.isProgramDirector? "Program Director" : "Program Coordinator";

    return (
        <div>
            <Navbar variant="dark" className="bg-secondary">
                <Container fluid={true}>
                    <ABPNNavLink />
                    {user &&
                        <div className="d-flex align-items-center justify-content-end">
                            <div className="d-flex text-end flex-column me-2 text-light pc-nav-font-size">
                                {user.selectedTrainingProgramId &&
                                  <Fragment>
                                    <h6 className="mb-1 mt-2 pe-2">{getProgramName(user.selectedTrainingProgramId)}</h6>
                                    <Dropdown className="d-flex ms-auto">
                                        <Dropdown.Toggle size="sm" variant="secondary" id="dropdown-program">
                                            {getSpecialtyName(user.selectedTrainingProgramId)}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="dropdown-menu-end text-nowrap">
                                            {user.trainingPrograms.map(program => <Dropdown.Item key={program.trainingProgramId} active={program.trainingProgramId === user.selectedTrainingProgramId} onClick={() => changeProgram(program.trainingProgramId)}>{getSpecialtyName(program.trainingProgramId)}</Dropdown.Item>)}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                  </Fragment>
                                }
                            </div>
                            <Dropdown className="nav-item">
                                <Dropdown.Toggle className="pc-nav-toggle pc-nav-dropdown-toggle pc-nav-btn rounded-circle text-secondary" variant="light">
                                    <OverlayTrigger placement={"left"} overlay={<Tooltip><div>{user.fullName}</div><div><i>{getRoleName()}</i></div></Tooltip>}>
                                        <div className="fw-bold mt-1 mb-1">{user.firstName.charAt(0)}{user.lastName.charAt(0)}</div>
                                    </OverlayTrigger>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu-end text-nowrap">
                                    <Dropdown.Item className="pc-nav-link font-weight-bold me-2" as={Link} to={logoutPath}>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    }
                </Container>
            </Navbar>
        </div>
    );
}
